// extracted by mini-css-extract-plugin
module.exports = {"flexContent":"Webhooks_flexContent__20mBt","newKeyBtn":"Webhooks_newKeyBtn__1tOaO","link":"Webhooks_link__2vqOt"};